module.exports = "/_next/static/images/crying_laughing-b9fd586c4b7cac645d36525a8b37dc4b.png";